"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * DTO object for a {@link Promotion promotion} containing all additional info for Promotion
 *
 * @author PKr
 */


var PromotionOverviewDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionOverviewDTO, _DomainObject_1$Domai);

  /**
   * @param id
   * @param totalWindowCount
   * @param rejectedCDWindowCount
   * @param rejectedPMWindowCount
   * @param preparedWindowCount
   * @param conceptWindowCount
   * @param approvedWindowCount
   * @param changedWindowCount
   * @param windowItemsCount
   * @param fcApprovalNeeded
   * @param locked
   * @param lockedForCurrentUser
   * @param haveSimulations
   */
  function PromotionOverviewDTO(id, totalWindowCount, rejectedCDWindowCount, rejectedPMWindowCount, preparedWindowCount, conceptWindowCount, approvedWindowCount, changedWindowCount, windowItemsCount, fcApprovalNeeded, locked, lockedForCurrentUser, haveSimulations) {
    var _this;

    _classCallCheck(this, PromotionOverviewDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionOverviewDTO).call(this));
    _this.id = id;
    _this.totalWindowCount = totalWindowCount;
    _this.rejectedCDWindowCount = rejectedCDWindowCount;
    _this.rejectedPMWindowCount = rejectedPMWindowCount;
    _this.preparedWindowCount = preparedWindowCount;
    _this.conceptWindowCount = conceptWindowCount;
    _this.approvedWindowCount = approvedWindowCount;
    _this.changedWindowCount = changedWindowCount;
    _this.windowItemsCount = windowItemsCount;
    _this.fcApprovalNeeded = fcApprovalNeeded;
    _this.locked = locked;
    _this.lockedForCurrentUser = lockedForCurrentUser;
    _this.haveSimulations = haveSimulations;
    return _this;
  }

  return PromotionOverviewDTO;
}(DomainObject_1.DomainObject);

exports.PromotionOverviewDTO = PromotionOverviewDTO;

PromotionOverviewDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionOverviewDTO.name);
  return {
    id: builder.id('id'),
    totalWindowCount: builder.num('totalWindowCount'),
    rejectedCDWindowCount: builder.num('rejectedCDWindowCount'),
    rejectedPMWindowCount: builder.num('rejectedPMWindowCount'),
    preparedWindowCount: builder.num('preparedWindowCount'),
    conceptWindowCount: builder.num('conceptWindowCount'),
    approvedWindowCount: builder.num('approvedWindowCount'),
    changedWindowCount: builder.num('changedWindowCount'),
    windowItemsCount: builder.num('windowItemsCount'),
    fcApprovalNeeded: builder.bool('fcApprovalNeeded'),
    locked: builder.bool('locked'),
    lockedForCurrentUser: builder.bool('lockedForCurrentUser'),
    haveSimulations: builder.bool('haveSimulations')
  };
}();